import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { ICoachingVideoApi } from './interfaces/coaching-video-abstract.api';
import { ApiHttpResponse, Coaching } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class CoachingVideoApi implements ICoachingVideoApi {
  constructor(private readonly http: HttpClient) { }

  getCoachingVideos(
    page: number,
    limit: number
  ): Observable<ApiHttpResponse<Coaching[]>> {
    const params = new HttpParams().set('page', page).set('limit', limit);
    const url = environment.api.dashboard.myCoachingVideos;
    return this.http.get<ApiHttpResponse<Coaching[]>>(url, { params });
  }

  deleteCoachingVideo(coachingVideoId: number): Observable<any> {
    const url = environment.api.dashboard.deleteCoaching.replace(
      '{video}',
      '' + coachingVideoId
    );
    return this.http.delete<any>(url);
  }
}
